<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <div style="height: 100%;">
        <div style="height: 50px">
          <el-date-picker v-fixZoom
            :clearable="false"
            v-model="alarmDate"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions2"
            value-format="yyyyMMdd"
            style="margin-right: 10px; width: 400px">
          </el-date-picker>
          <el-button type="primary" @click="getTablePhoneCall">查询</el-button>
          <el-button icon="el-icon-download" type="success" @click="getAllCallHistoryByDate">导出当前所选日期客服关爱记录</el-button>
        </div>
        <div style="max-height: calc(100% - 100px);overflow-y: auto;">
          <el-table
            v-loading="loading"
            element-loading-text="Loading"
            :data="tableData"
            border
            style="width: 100%;margin-top: 10px">
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center">
            </el-table-column>
            <el-table-column
              prop="p_name"
              label="长者姓名"
              min-width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="calloutphone"
              label="长者电话"
              min-width="140"
              align="center">
            </el-table-column>
            <el-table-column
              prop="remarktime"
              label="回访时间"
              min-width="140"
              align="center">
            </el-table-column>
            <el-table-column
              prop="remark"
              label="回访记录"
              min-width="150"
              align="center">
            </el-table-column>
            <el-table-column
              prop="sp_name"
              label="客服姓名"
              min-width="80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="calltime"
              label="响铃时间"
              min-width="140"
              align="center">
            </el-table-column>
            <el-table-column
              label="接通时间"
              min-width="140"
              align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.begintime !== '0000-00-00 00:00:00'">{{scope.row.begintime}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="endtime"
              label="结束时间"
              min-width="140"
              align="center">
            </el-table-column>
            <el-table-column
              label="通话时长"
              min-width="140"
              align="center">
              <template slot-scope="scope">
                <span>{{getCallTime(scope.row)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 10px;height: 40px;text-align: center">
          <el-pagination v-fixZoom
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCells">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {queryendphonecalllist} from '../../api/callphone'

export default {
  name: 'callPhone',
  data () {
    return {
      loading: false,
      alarmDate: [],
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      // 表格
      tableData: [],
      showTable: [],
      currentPage: 1,
      pageSize: 10,
      totalCells: 0,
      // 服务对象
      personlist: [],
      // 客服人员
      userList: []
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyyMMdd')
    this.alarmDate = [date, date]
    this.getTimeObj()
    this.getTablePhoneCall()
  },
  mounted () {},
  methods: {
    // 时间
    mGetDate (year, month) {
      let d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      let dataArr = []
      let data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + arr[1] + '01'
        obj.end = arr[0] + arr[1] + endDay
        endDate.push(obj)
      }
      // console.log('end', endDate)
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions2.shortcuts = arrTime
    },
    // 查询
    getTablePhoneCall () {
      this.loading = true
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        from: this.alarmDate[0] + '000000',
        to: this.alarmDate[1] + '235959'
      }
      queryendphonecalllist(params, data).then(res => {
        this.tableData = res.data.phonecalllist
        this.totalCells = res.data.cnt
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getCallTime (row) {
      if (row.endtime !== '0000-00-00 00:00:00' && row.endtime !== '' && row.begintime !== '0000-00-00 00:00:00' && row.begintime !== '') {
        const stime = Date.parse(new Date(row.begintime))
        const etime = Date.parse(new Date(row.endtime))
        // 两个时间戳相差的毫秒数
        const usedTime = etime - stime
        // 计算相差的天数
        const days = Math.floor(usedTime / (24 * 3600 * 1000))
        // 计算天数后剩余的毫秒数
        const leave1 = usedTime % (24 * 3600 * 1000)
        // 计算出小时数
        const hours = Math.floor(leave1 / (3600 * 1000))
        // 计算小时数后剩余的毫秒数
        const leave2 = leave1 % (3600 * 1000)
        // 计算相差分钟数
        const minutes = Math.floor(leave2 / (60 * 1000))
        // 计算分钟数后剩余的毫秒数
        const leave3 = leave2 % (60 * 1000)
        // 计算相差秒数
        const second = Math.floor(leave3 / 1000)
        let time = ''
        if (days !== 0) {
          time = days + '天' + hours + '时' + minutes + '分' + second + '秒'
        } else if (hours !== 0) {
          time = hours + '时' + minutes + '分' + second + '秒'
        } else if (minutes !== 0) {
          time = minutes + '分' + second + '秒'
        } else {
          time = second + '秒'
        }
        return time
        // const time = days + '天' + hours + '时' + minutes + '分' + second + '秒'
        // console.log(time)  // 1天0时3分17秒
      }
    },
    // 导出
    getAllCallHistoryByDate () {
      this.$message({
        type: 'info',
        message: '数据加载中，请耐心等待。',
        duration: 0
      })
      let params = {
        page: 1,
        size: 10
      }
      let data = {
        from: this.alarmDate[0] + '000000',
        to: this.alarmDate[1] + '235959'
      }
      queryendphonecalllist(params, data).then(res => {
        if (res.data.cnt === 0) {
          this.$message.closeAll()
          this.$message({
            type: 'success',
            message: '暂无报警信息。'
          })
        }
        if (res.data.cnt > 10) {
          this.download1(res.data.cnt)
        } else if (res.data.cnt > 0 && res.data.cnt <= 10) {
          let arr = []
          let arr1 = res.data.phonecalllist
          for (let i = 0; i < arr1.length; i++) {
            let obj = arr1[i]
            obj.spendtime = this.getCallTime(obj)
            arr.push(obj)
          }
          this.download2(arr)
        }
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    download1 (cnt) {
      let params = {
        page: 1,
        size: cnt
      }
      let data = {
        from: this.alarmDate[0] + '000000',
        to: this.alarmDate[1] + '235959'
      }
      queryendphonecalllist(params, data).then(res => {
        let arr = []
        let arr1 = res.data.phonecalllist
        for (let i = 0; i < arr1.length; i++) {
          let obj = arr1[i]
          obj.spendtime = this.getCallTime(obj)
          arr.push(obj)
        }
        this.download2(arr)
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    download2 (arr) {
      // console.log(arr)
      import('../../vendor/Export2Excel').then(excel => {
        const tHeader = ['长者姓名', '长者电话', '回访时间', '回访记录', '客服姓名', '响铃时间', '接通时间', '结束时间', '通话时长']
        const filterVal = ['p_name', 'fromnum', 'remarktime', 'remark', 'sp_name', 'calltime', 'begintime', 'endtime', 'spendtime']
        const list = arr
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.alarmDate[0] + '-' + this.alarmDate[1] + '客服关爱统计'
        })
      })
      setTimeout(() => {
        this.$message.closeAll()
      }, 1500)
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    // 页码
    handleSizeChange (val) {
      this.pageSize = val
      // this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      this.getTablePhoneCall()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTablePhoneCall()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticalform/callPhone.vue